import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=72e870ca&scoped=true&"
import script from "./JobDetail.vue?vue&type=script&lang=ts&"
export * from "./JobDetail.vue?vue&type=script&lang=ts&"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=72e870ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e870ca",
  null
  
)

export default component.exports